import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $dateType: [QueryArgument], $draftId: Int, $revisionId: Int) {
        data: entries(
            section: "dates"
            dateType: $dateType
            siteId: $siteId
            draftId: $draftId
            revisionId: $revisionId
        ) {
            ... on dates_default_Entry {
                title
                dateType
                dateItems {
                    ... on dateItem_Entry {
                        text
                        text2
                        dateExpires
                        addEventLink
                    }
                }
            }
        }
    }
`
